<template>
  <v-container fluid pa-0 grid-list-md class="chat-center-container">
    <v-layout justify-center mx-0>
      <v-flex md8>
        <v-layout row wrap>
          <v-flex md12 pt-4 px-4>
            <v-card>
              <v-card-text class="pa-0">
                <template v-if="Object.keys(customer).length">
                  <v-tabs
                    grow
                    color="transparent"
                    class="border-top border-bottom"
                    v-model="active">
                    <v-tabs-slider color="k-orange-linear"></v-tabs-slider>
                    <v-tab href="#tab-1">
                      Información general
                    </v-tab>
                    <v-tab href="#tab-2">
                      Información financiera
                    </v-tab>
                    <v-tab href="#tab-3">
                      Saldos
                    </v-tab>
                    <v-tab href="#tab-4" v-if="dimentions.length > 0 || hasInfo || customer.portfolio_benchmark_id">
                      Otra informacion
                    </v-tab>
                  </v-tabs>
                  <v-tabs-items v-model="active">
                    <v-tab-item id="tab-1">
                      <v-layout row wrap class="pb-3 pt-3">
                        <v-flex xs12 pl-4 style="border-bottom: 1px solid #ccc;">
                          <template v-if="!editCustomer">
                            <v-layout justify-center align-center class="align-items-center" mb-3>
                              <v-flex md11 pr-2 pt-2 class="text-capitalize">
                                <h2 clas="d-inline-block">
                                  {{ customer.name ? customer.name.toLowerCase() : customer.first_name ? customer.first_name : 'Sin especificar' }}
                                </h2>
                              </v-flex>
                              <v-flex md1 mr-4 pt-2>
                                <v-btn small icon class="grey--text" @click="editSelectCustomer(customer)">
                                  <v-icon small>fas fa-pencil-alt</v-icon>
                                </v-btn>
                              </v-flex>
                            </v-layout>
                            <v-layout row wrap mb-4>
                              <v-flex md3 style="word-break: break-all;">
                                <small>Cuenta</small>
                                <br>
                                {{ customer.account || 'Sin especificar' }}
                              </v-flex>
                              <v-flex md3 style="word-break: break-all;">
                                <small>RUT/DNI/CI</small>
                                <br>
                                {{ customer.fiscal_id || 'Sin especificar' }}
                              </v-flex>
                              <v-flex md3>
                                <small>Última carga</small>
                                <br>
                                {{ customer.last_sync_date ? formatDate(customer.last_sync_date, 'YYYY-MM-DD', 'DD/MM/YYYY') : 'Sin especificar'}}
                              </v-flex>
                              <v-flex md3>
                                <small>Estado</small>
                                <br>
                                {{ $store.getters.customerStatus(customer.customer_status_id).name || 'Sin especificar' }}
                              </v-flex>
                              <v-flex md3>
                                <small>Sub-estado</small>
                                <br>
                                {{ !customer.sub_status_id ? 'Sin especificar' : $store.getters.subStatus(customer.sub_status_id).name }}
                              </v-flex>
                              <v-flex md3>
                                <small>Asesor</small>
                                <br>
                                {{ agent(customer.agent_id).name || 'Sin especificar' }}
                              </v-flex>
                               <v-flex md3>
                                <small>Etapa</small>
                                <br>
                                <template v-if="customer.workflowStageStart">
                                  {{`${customer.workflowStageStart} a ${customer.workflowStageEnd} días de mora`}}
                                </template>
                                <template v-else>
                                  Sin especificar
                                </template>
                              </v-flex>
                              <v-flex md3 v-if="customer.test" justify-space-around class="text-xs-center">
                                <small>Etapa</small>
                                <br>
                                {{customer.test || 'Sin información'}}
                              </v-flex>
                              <v-flex md3>
                                <small>Genero</small>
                                <br />
                                <p class="caption">{{gender(customer.gender_id).name || 'Sin información'}}</p>
                              </v-flex>
                              <v-flex md3>
                                <small>Edad</small>
                                <br />
                                <p class="caption">{{customer.age || 'Sin información'}}</p>
                              </v-flex>
                              <v-flex md3>
                                <small>Grupo de edad</small>
                                <br />
                                <p class="caption">{{ ageGroup(customer.age_group_id).name || 'Sin información' }}</p>
                              </v-flex>
                              <v-flex md3>
                                <small>Estado / Región</small>
                                <br />
                                <p class="caption">{{ state(customer.state_id).name || 'Sin información' }}</p>
                              </v-flex>
                              <v-flex md3 v-if="customer.company_id === 4834400">
                                <small>Codigo postal</small>
                                <br />
                                <p class="caption">{{ customer.reference || 'Sin información' }}</p>
                              </v-flex>
                              <v-flex md3>
                                <small>Fecha de nacimiento</small>
                                <br />
                                <p class="caption">{{ customer.birthday | transformBirthday }}</p>
                              </v-flex>
                              <v-flex md3>
                                <small>Fecha de Vencimiento</small>
                                <br />
                                <p
                                  class="caption"
                                >{{ customer.due_date ? formatDate(customer.due_date, 'YYYY-MM-DD', 'DD/MM/YYYY') : 'Sin especificar'}}</p>
                              </v-flex>
                              <v-flex md3>
                                <small>Marca</small>
                                <br />
                                <p
                                  class="caption"
                                >{{customer.ns_informative == 0 ? 'Cobranza' : 'Informativo'}}</p>
                              </v-flex>
                              <v-flex md3>
                                <small>Alivia</small>
                                <br />
                                <p class="caption">{{ aliviaCheck }}</p>
                              </v-flex>
                              <v-flex md3 v-if="customer.company_id === 71408715">
                                <small>Ciudad</small>
                                <br />
                                <p class="caption">{{ customer.city }}</p>
                              </v-flex>
                              <v-flex md3 v-if="customer.company_id === 71408715">
                                <small>Dirección</small>
                                <br />
                                <p class="caption">{{ customer.address }}</p>
                              </v-flex>
                            </v-layout>
                          </template>
                          <template v-else>
                            <v-container grid-list-lg pt-0 pb-0>
                              <v-layout justify-center align-center class="align-items-center" px-3 mb-3>
                                <v-flex md11 pt-2 class="transform-upper-case text-capitalize">
                                  <v-text-field
                                    class=""
                                    color="black"
                                    v-model="form.nombre"
                                    :error-messages="errors.collect('name')"
                                    v-validate="customer.name ? 'required|max:100' : 'max:100'"
                                    data-vv-name="name"
                                    data-vv-as="nombre"
                                    data-vv-scope="customer-form"
                                    label="Nombre"
                                  ></v-text-field>
                                </v-flex>
                                <v-flex md1 pt-2>
                                  <v-btn small icon class="grey--text" @click="editCustomer = false">
                                    <v-icon small>fas fa-times</v-icon>
                                  </v-btn>
                                </v-flex>
                              </v-layout>
                              <v-layout row wrap text-xs-center>
                                <v-flex md3 class="custom-input">
                                  <v-text-field
                                    class=""
                                    color="black"
                                    label="Cuenta"
                                    v-model="form.cuenta"
                                    :error-messages="errors.collect('account')"
                                    v-validate="customer.account ? 'required|max:100' : 'max:100'"
                                    data-vv-name="account"
                                    data-vv-as="cuenta"
                                    data-vv-scope="customer-form"
                                  ></v-text-field>
                                </v-flex>
                                <v-flex md3 class="custom-input">
                                  <v-text-field
                                    class=""
                                    color="black"
                                    label="RUT/DNI/CI"
                                    :error-messages="errors.collect('fiscal')"
                                    v-validate="customer.fiscal_id ? 'required|max:100' : 'max:100'"
                                    data-vv-name="fiscal"
                                    data-vv-as="RUT/DNI/CI"
                                    data-vv-scope="customer-form"
                                    v-model="form.fiscal"
                                  ></v-text-field>
                                </v-flex>
                                <v-flex md3 class="custom-input">
                                  <v-select
                                    class=""
                                    color="black"
                                    :items="genders"
                                    item-value="id"
                                    item-text="name"
                                    label="Genero"
                                    v-model="form.genero"
                                  ></v-select>
                                </v-flex>
                                <v-flex md3 class="custom-input">
                                  <v-text-field
                                    class=""
                                    color="black"
                                    label="Edad"
                                    v-validate="form.age ? 'required|numeric|min_value:0' : 'numeric|min_value:0'"
                                    data-vv-name="age"
                                    data-vv-as="Edad"
                                    data-vv-scope="customer-form"
                                    :error-messages="errors.collect('age')"
                                    v-model="form.edad"
                                  ></v-text-field>
                                </v-flex>
                                <v-flex class="custom-input" :md6="form.status_id === 2" :md3="form.status_id !== 2">
                                  <v-select
                                    class=""
                                    color="black"
                                    :items="agents"
                                    label="Asesor"
                                    item-value="id"
                                    item-text="name"
                                    v-model="form.agent_id"
                                  ></v-select>
                                </v-flex>
                                <v-flex class="custom-input" md3>
                                  <v-select
                                    class=""
                                    color="black"
                                    :items="statusCustomers.customer"
                                    label="Estado"
                                    item-value="id"
                                    item-text="status"
                                    v-model="form.status_id"
                                    autocomplete
                                  ></v-select>
                                </v-flex>
                                <v-flex class="custom-input" md3>
                                  <v-select
                                    class=""
                                    color="black"
                                    :items="$store.getters.customerSubStatuses"
                                    label="Sub-estado"
                                    item-value="id"
                                    item-text="name"
                                    v-model="form.sub_status_id"
                                  ></v-select>
                                </v-flex>
                                <v-flex class="custom-input" md3 v-if="form.status_id === 2">
                                  <v-menu
                                    ref="Detailfrom"
                                    :close-on-content-click="false"
                                    :nudge-right="40"
                                    :return-value.sync="form.payment_promise"
                                    transition="scale-transition"
                                    min-width="290px"
                                    lazy
                                    offset-y
                                    full-width>
                                      <v-text-field
                                        slot="activator"
                                        v-model="dateFormattedPaymentPromise"
                                        append-icon="event"
                                        label="Fecha de compromiso"
                                        readonly
                                        color="black">
                                      </v-text-field>
                                      <v-date-picker
                                        v-model="form.payment_promise"
                                        @input="$refs.Detailfrom.save(form.payment_promise)"
                                        locale="es"
                                        color="k-orange-linear">
                                      </v-date-picker>
                                  </v-menu>
                                </v-flex>
                              </v-layout>
                              <v-layout row wrap text-xs-center>
                                <v-flex md12 class="text-xs-center">
                                  <v-btn flat class="k-orange-linear-text" :disabled="errors.any('customer-form')" @click="updateCustomer()">GUARDAR</v-btn>
                                </v-flex>
                              </v-layout>
                            </v-container>
                          </template>
                        </v-flex>
                      </v-layout>
                      <v-layout row wrap class="pb-3">
                        <v-flex xs6 style="border-right: 1px solid #ccc;">
                          <v-list two-line class="pa-0">
                            <vue-perfect-scrollbar class="chat-details--scrollbar">
                              <template v-if="createPhone">
                                <v-list-tile class="custom-tile pr-0">
                                  <v-list-tile-action>
                                    <v-icon>phone</v-icon>
                                  </v-list-tile-action>
                                  <v-list-tile-content>
                                    <v-layout justify-center align-center pt-3 mr-4>
                                      <v-flex md6>
                                        <v-text-field
                                          color="black"
                                          label="Telefono"
                                          v-validate="'required'"
                                          data-vv-name="phone"
                                          data-vv-as="telefono"
                                          data-vv-scope="phone-form"
                                          :error-messages="errors.collect('phone-form.phone')"
                                          v-model="form.phone.telefono"
                                        ></v-text-field>
                                      </v-flex>
                                      <v-flex md4 pl-3>
                                        <v-select
                                          color="black"
                                          label="Tipo"
                                          :items="typeCustomers.phone"
                                          item-text="type"
                                          item-value="type"
                                          v-validate="'required'"
                                          data-vv-name="type"
                                          data-vv-as="tipo"
                                          data-vv-scope="phone-form"
                                          :error-messages="errors.collect('phone-form.type')"
                                          v-model="form.phone.tipoPhone"
                                        ></v-select>
                                      </v-flex>
                                      <v-flex md1 pb-3>
                                        <v-btn small icon @click="createPhone = false" class="grey--text">
                                          <v-icon small>fas fa-times</v-icon>
                                        </v-btn>
                                      </v-flex>
                                      <v-flex md1 pb-3 pl-1>
                                        <v-btn small icon @click="updatePhone(form.phone, 'create')" class="grey--text">
                                          <v-icon small>fas fa-check</v-icon>
                                        </v-btn>
                                      </v-flex>
                                    </v-layout>
                                  </v-list-tile-content>
                                </v-list-tile>
                              </template>
                              <template v-else>
                                <v-list-tile @click="editSelectPhone('create')" :class="{'mr-2':customer.customer_phones.length > 2}" v-if="canCreateContact">
                                  <v-list-tile-action>
                                    <v-icon>phone</v-icon>
                                  </v-list-tile-action>
                                  <v-list-tile-content>
                                    <v-list-tile-title class="pl-1">Agregar nuevo telefono</v-list-tile-title>
                                  </v-list-tile-content>
                                </v-list-tile>
                              </template>
                              <template
                                v-if="customer.customer_phones.length"
                                v-for="(phone, i) in customer.customer_phones">
                                <template v-if="editPhone === phone.id">
                                  <v-list-tile
                                  :key="`phone-edit-${i}`"
                                  class="custom-tile pr-0">
                                    <v-list-tile-action>
                                      <v-icon>phone</v-icon>
                                    </v-list-tile-action>
                                    <v-list-tile-content>
                                      <v-layout justify-center align-center pt-3 mr-4>
                                        <v-flex md6>
                                          <v-text-field
                                            color="black"
                                            label="Telefono"
                                            v-model="form.phone.telefono"
                                          ></v-text-field>
                                        </v-flex>
                                        <v-flex md4 pl-3>
                                          <v-select
                                            color="black"
                                            label="Tipo"
                                            :items="typeCustomers.phone"
                                            item-text="type"
                                            item-value="type"
                                            v-model="form.phone.tipoPhone"
                                          ></v-select>
                                        </v-flex>
                                        <v-flex md1 pb-3>
                                          <v-btn small icon @click="closeEditPhone()" class="grey--text">
                                            <v-icon small>fas fa-times</v-icon>
                                          </v-btn>
                                        </v-flex>
                                        <v-flex md1 pb-3 pl-1>
                                          <v-btn small icon @click="updatePhone(form.phone)" class="grey--text">
                                            <v-icon small>fas fa-check</v-icon>
                                          </v-btn>
                                        </v-flex>
                                      </v-layout>
                                    </v-list-tile-content>
                                  </v-list-tile>
                                </template>
                                <template v-else>
                                  <v-list-tile
                                  :key="`phone-${i}`"
                                  class="contact-method-tile"
                                  @click="editSelectPhone(phone)">
                                    <v-list-tile-action class="contact-method-leading">
                                      <v-icon>phone</v-icon>
                                    </v-list-tile-action>
                                    <v-list-tile-content class="contact-method-content">
                                      <v-list-tile-title class="contact-method-title">
                                        <span class="contact-method-phone">{{ phone.phone }}</span>
                                        <v-chip
                                          class="button-chip x-small-chip contactability-chip"
                                          :class="getPhoneContactabilityClass(phone)">
                                          {{ getPhoneContactabilityLabel(phone) }}
                                        </v-chip>
                                      </v-list-tile-title>
                                      <v-list-tile-sub-title class="contact-method-meta">
                                        <v-menu offset-y @click.native.stop>
                                          <v-chip slot="activator" class="button-chip x-small-chip a-borders transparent-no-border k-grey-light-text">
                                            <v-icon class="f0-9em pr-2">fas {{phone.status === 'Valido' ? 'fa-check-circle' : phone.status === 'Por validar' ? 'fa-exclamation-circle' : 'fa-times-circle' }}</v-icon>
                                            {{phone.status}}
                                          </v-chip>
                                          <v-list>
                                            <v-list-tile v-for="(status, i) in statusCustomers.contacts" @click="setStatus('phone', phone.id, status)" :key="`${status}-phone-${i}-status`">
                                              <v-list-tile-title>{{ status }}</v-list-tile-title>
                                            </v-list-tile>
                                          </v-list>
                                        </v-menu>
                                        <v-chip class="button-chip x-small-chip a-borders transparent-no-border k-grey-light-text">
                                          {{getPhoneOrigin(phone.origin_id)}}
                                        </v-chip>
                                        <v-chip v-if="phone.customer_phone_owner" class="button-chip x-small-chip a-borders transparent-no-border k-grey-light-text">
                                          {{ phone.customer_phone_owner.owner }}
                                        </v-chip>
                                      </v-list-tile-sub-title>
                                    </v-list-tile-content>
                                    <v-list-tile-action
                                      v-if="phone.status !== 'Invalido'"
                                      class="contact-method-actions"
                                      @click.native.stop>
                                      <div class="contact-method-actions__group">
                                        <v-tooltip left v-if="!isCalling && canCallContact">
                                          <v-btn
                                            icon
                                            fab
                                            class="k-orange-linear call-button"
                                            slot="activator"
                                            @click.stop="callCustomer(phone.id)">
                                            <v-icon color="white">
                                              fas fa-phone fa-rotate-90
                                            </v-icon>
                                          </v-btn>
                                          <span>Llamar</span>
                                        </v-tooltip>
                                        <v-tooltip
                                          left
                                          v-if="phone.type !== 'Fijo' && user.company_id !== 18622237">
                                          <v-btn
                                            slot="activator"
                                            icon
                                            fab
                                            class="k-orange-linear call-button"
                                            @click.stop="makeChatCenter(phone, 2)">
                                            <v-icon color="white">
                                              fas fa-comments
                                            </v-icon>
                                          </v-btn>
                                          <span>Enviar SMS</span>
                                        </v-tooltip>
                                      </div>
                                    </v-list-tile-action>
                                  </v-list-tile>
                                </template>
                              </template>
                            </vue-perfect-scrollbar>
                          </v-list>
                        </v-flex>
                        <v-flex xs6>
                          <v-list two-line class="pa-0">
                            <vue-perfect-scrollbar class="chat-details--scrollbar">
                              <template v-if="createEmail">
                                <v-list-tile class="custom-tile pr-0">
                                  <v-list-tile-action>
                                    <v-icon>mail</v-icon>
                                  </v-list-tile-action>
                                  <v-list-tile-content>
                                    <v-layout justify-center align-center pt-3 mr-4>
                                      <v-flex md6>
                                        <v-text-field
                                          color="black"
                                          label="Email"
                                          v-validate="'required|email'"
                                          data-vv-name="email"
                                          data-vv-as="email"
                                          data-vv-scope="email-form"
                                          :error-messages="errors.collect('email-form.email')"
                                          v-model="form.email.email"
                                        ></v-text-field>
                                      </v-flex>
                                      <v-flex md4 pl-3>
                                        <v-select
                                          color="black"
                                          label="Tipo"
                                          :items="typeCustomers.email"
                                          item-text="type"
                                          item-value="type"
                                          v-validate="'required'"
                                          data-vv-name="type"
                                          data-vv-as="tipo"
                                          data-vv-scope="email-form"
                                          :error-messages="errors.collect('email-form.type')"
                                          v-model="form.email.type"
                                        ></v-select>
                                      </v-flex>
                                      <v-flex md1 pb-3>
                                        <v-btn small icon @click="createEmail = false" class="grey--text">
                                          <v-icon small>fas fa-times</v-icon>
                                        </v-btn>
                                      </v-flex>
                                      <v-flex md1 pb-3 pl-1>
                                        <v-btn small icon @click="updateEmail(form.email, 'create')" class="grey--text">
                                          <v-icon small>fas fa-check</v-icon>
                                        </v-btn>
                                      </v-flex>
                                    </v-layout>
                                  </v-list-tile-content>
                                </v-list-tile>
                              </template>
                              <template v-else>
                                <v-list-tile @click="editSelectEmail('create')" :class="{'mr-2':customer.customer_emails.length > 2}" v-if="canCreateContact">
                                  <v-list-tile-action>
                                    <v-icon>mail</v-icon>
                                  </v-list-tile-action>
                                  <v-list-tile-content>
                                    <v-list-tile-title class="pl-1">Agregar nuevo email</v-list-tile-title>
                                  </v-list-tile-content>
                                </v-list-tile>
                              </template>
                              <template
                                v-if="customer.customer_emails.length"
                                v-for="(email, i) in customer.customer_emails">
                                <template v-if="editEmail === email.id">
                                  <v-list-tile
                                  :key="`edit-email-${i}`"
                                  class="custom-tile pr-0">
                                    <v-list-tile-action>
                                      <v-icon>mail</v-icon>
                                    </v-list-tile-action>
                                    <v-list-tile-content>
                                      <v-layout justify-center align-center pt-3 mr-4>
                                        <v-flex md6>
                                          <v-text-field
                                            color="black"
                                            label="Email"
                                            v-model="form.email.email"
                                          ></v-text-field>
                                        </v-flex>
                                        <v-flex md4 pl-3>
                                          <v-select
                                            color="black"
                                            label="Tipo"
                                            :items="typeCustomers.email"
                                            item-text="type"
                                            item-value="type"
                                            v-model="form.email.type"
                                          ></v-select>
                                        </v-flex>
                                        <v-flex md1 pb-3>
                                          <v-btn small icon @click="closeEditEmail()" class="grey--text">
                                            <v-icon small>fas fa-times</v-icon>
                                          </v-btn>
                                        </v-flex>
                                        <v-flex md1 pb-3 pl-1>
                                          <v-btn small icon @click="updateEmail(form.email)" class="grey--text">
                                            <v-icon small>fas fa-check</v-icon>
                                          </v-btn>
                                        </v-flex>
                                      </v-layout>
                                    </v-list-tile-content>
                                  </v-list-tile>
                                </template>
                                <template v-else>
                                  <v-list-tile
                                  :key="`email-${i}`"
                                  @click="editSelectEmail(email)"
                                  :class="{'mr-2':customer.customer_emails.length > 2}">
                                    <v-list-tile-action>
                                      <v-icon>mail</v-icon>
                                    </v-list-tile-action>
                                    <v-list-tile-content>
                                      <v-list-tile-title class="pl-1">{{ email.email }}</v-list-tile-title>
                                      <v-list-tile-sub-title>
                                        <v-layout align-center>
                                          <v-flex md4>
                                            <v-menu offset-y  @click.native.stop>
                                              <v-chip slot="activator" class="button-chip x-small-chip a-borders transparent-no-border k-grey-light-text">
                                                <v-icon class="f0-9em pr-2">fas {{email.status === 'Valido' ? 'fa-check-circle' : email.status === 'Por validar' ? 'fa-exclamation-circle' : 'fa-times-circle' }}</v-icon>
                                                {{email.status}}
                                              </v-chip>
                                              <v-list>
                                                <v-list-tile v-for="(status, i) in statusCustomers.contacts" @click="setStatus('email', email.id, status)" :key="`${status}-email-${i}-status`">
                                                  <v-list-tile-title>{{status}}</v-list-tile-title>
                                                </v-list-tile>
                                              </v-list>
                                            </v-menu>
                                          </v-flex>
                                        </v-layout>
                                      </v-list-tile-sub-title>
                                    </v-list-tile-content>
                                    <v-list-tile-action v-if="email.status !== 'Invalido' && $auth.user().company_id !== 18622237">
                                      <v-tooltip left>
                                          <v-btn slot="activator"  icon fab class="k-orange-linear call-button" @click.stop="makeChatCenter(email, 1)">
                                            <v-icon color="white">
                                              fas fa-comments
                                            </v-icon>
                                          </v-btn>
                                        <span>
                                          Crear chatcenter
                                        </span>
                                      </v-tooltip>
                                    </v-list-tile-action>
                                  </v-list-tile>
                                </template>
                              </template>
                            </vue-perfect-scrollbar>
                            <v-divider inset v-if="customer.customer_emails.length"></v-divider>
                          </v-list>
                        </v-flex>
                      </v-layout>
                      <v-layout class="card-container" mt-2 mb-4 px-3>
                        <v-flex xs3 class="card-btn">
                          <v-card class="elevation-3 hovered" :class="{ 'k-orange-linear': notificationPending }">
                            <v-card-text class="py-0 px-3" @click="notificationPending = true">
                              <v-layout justify-center align-center class="h-100">
                                <v-icon class="k-orange-linear-text mr-3" :class="{ 'white--text': notificationPending }">fas fa-clipboard-list</v-icon>
                                <span>Llamadas Agendadas</span>
                              </v-layout>
                            </v-card-text>
                          </v-card>
                        </v-flex>
                        <!-- <v-flex xs3 class="card-btn">
                          <v-card class="elevation-3 hovered" :class="{ 'k-orange-linear': refinancingDialog }">
                            <v-card-text class="py-0 px-3" @click="refinancingDialog = true">
                              <v-layout justify-center align-center class="h-100">
                                <v-icon class="k-orange-linear-text mr-3" :class="{ 'white--text': refinancingDialog }">fas fa-dollar-sign</v-icon>
                                <span>Refinanciamientos</span>
                              </v-layout>
                            </v-card-text>
                          </v-card>
                        </v-flex> -->
                        <v-flex xs3 class="card-btn">
                          <v-card class="elevation-3 hovered" :class="{ 'k-orange-linear': showPayments }">
                            <v-card-text class="py-0 px-3" @click="showPayments = true">
                              <v-layout justify-center align-center class="h-100">
                                <v-icon class="k-orange-linear-text mr-3" :class="{ 'white--text': showPayments }">fas fa-hand-holding-usd</v-icon>
                                <span>Pagos</span>
                              </v-layout>
                            </v-card-text>
                          </v-card>
                        </v-flex>
                        <v-flex xs3 class="card-btn">
                          <v-card class="elevation-3 hovered" :class="{ 'k-orange-linear': duesDialog }">
                            <v-card-text class="py-0 px-3" @click="duesDialog = true">
                              <v-layout justify-center align-center class="h-100">
                                <v-icon class="k-orange-linear-text mr-3" :class="{ 'white--text': duesDialog }">fas fa-tasks</v-icon>
                                <span>{{duesName}}</span>
                              </v-layout>
                            </v-card-text>
                          </v-card>
                        </v-flex>
                        <v-flex xs3 class="card-btn">
                          <v-card class="elevation-3 hovered" :class="{ 'k-orange-linear': showAgreements }">
                            <v-card-text class="py-0 px-3" @click="showAgreements = true">
                              <v-layout justify-center align-center class="h-100">
                                <v-icon class="k-orange-linear-text mr-3" :class="{ 'white--text': showAgreements }">fas fa-file-alt</v-icon>
                                <span>Convenios</span>
                              </v-layout>
                            </v-card-text>
                          </v-card>
                        </v-flex>
                        <v-flex xs3 class="card-btn">
                          <v-card class="elevation-3 hovered" :class="{ 'k-orange-linear': showCustomerTrackingLogsDialog }">
                            <v-card-text class="py-0 px-3" @click="showCustomerTrackingLogsDialog = true">
                              <v-layout justify-center align-center class="h-100">
                                <v-icon class="k-orange-linear-text mr-3" :class="{ 'white--text': showCustomerTrackingLogsDialog }">fas fa-list</v-icon>
                                <span>Seguimientos</span>
                              </v-layout>
                            </v-card-text>
                          </v-card>
                        </v-flex>
                      </v-layout>
                    </v-tab-item>
                    <v-tab-item id="tab-2">
                      <financial-info
                        :customer="customer">
                      </financial-info>
                    </v-tab-item>
                    <v-tab-item id="tab-3">
                      <balance-info
                        :customer="customer">
                      </balance-info>
                    </v-tab-item>
                    <v-tab-item id="tab-4" v-if="dimentions.length > 0 || hasInfo || customer.portfolio_benchmark_id">
                      <other-info
                        :customer="customer"
                        :dimentions="dimentions">
                      </other-info>
                    </v-tab-item>
                  </v-tabs-items>
                </template>
              </v-card-text>
            </v-card>
          </v-flex>
          <v-flex>
            <v-layout row wrap px-4>
              <v-flex pt-2 md6>
                <v-text-field
                  v-model="filterTimeline.search"
                  label="Buscar por codigo de plantilla, telefono o email"
                  color="black"
                  append-icon="fas fa-search"
                  class=" h-46"
                  solo>
                </v-text-field>
              </v-flex>
              <v-flex pt-2 pl-2 md4>
                <v-select
                  v-model="filterTimeline.status"
                  :items="statuses"
                  label="Estados"
                  item-value="status_id"
                  item-text="status"
                  class=""
                  color="grey"
                  solo>
                  <template slot="selection" slot-scope="data" >
                    <div class="black--text" v-if="data.item.value === -1">{{ data.item.status }} ({{data.item.total}}</div>
                    <div class="black--text" v-else>{{ storeStatus(data.item.value).status }} ({{data.item.total}})</div>
                  </template>
                  <template slot="item" slot-scope="data">
                    <template v-if="typeof data.item !== 'object'">
                      <v-list-tile-content v-text="data.item"></v-list-tile-content>
                    </template>
                    <template v-else>
                      <v-list-tile-content>
                        <div class="black--text" v-if="data.item.value === -1">{{ data.item.status }} ({{data.item.total}}</div>
                        <div class="black--text" v-else>{{ storeStatus(data.item.value).status }} ({{data.item.total}})</div>
                      </v-list-tile-content>
                    </template>
                  </template>
                </v-select>
              </v-flex>
              <v-flex pt-2 md2 pl-2>
                <v-btn block large class="ma-0" @click="generateReport">
                  <v-icon small>fas fa-download</v-icon>
                </v-btn>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex md12 class="white mx-4 mt-2">
            <v-layout justify-center align-center class="hovereable w-100 py-4" @click="dialogSchedule = true">
              <v-flex md12 text-xs-center>
                Agregar gestión <v-icon class="pl-1" small>fas fa-plus</v-icon>
              </v-flex>
            </v-layout>
            <v-divider></v-divider>
            <vue-perfect-scrollbar :class="{'payment--scrollbar white':true, 'show-binance':showMoreBinance}" v-if="notificationSchedules.length">
              <v-layout row wrap flat>
                <v-expansion-panel class="elevation-0">
                  <v-expansion-panel-content
                    v-for="(schedule, i) in notificationSchedules"
                    :key="i"
                    @input="getStep($event, i)"
                  >
                    <template slot="header">
                      <v-layout justify-center align-center class="w-100 py-1">
                        <v-flex md1>
                          <v-avatar
                            size="40"
                            class="k-orange-linear"
                          >
                            {{ i + 1 }}
                          </v-avatar>
                        </v-flex>
                        <v-flex md3>
                          <v-layout row wrap>
                            <v-flex xs12>
                              <span v-if="schedule.channel_id === 5 && schedule.type_id === 1">
                                CALL CENTER
                              </span>
                              <span v-else-if="schedule.channel_id === 5 && schedule.type_id === 6">
                                CALL INDIVIDUAL
                              </span>
                              <span v-else>
                                {{ showNameChannel(schedule.channel_id, 'upperAll') }}
                              </span>
                            </v-flex>
                            <v-flex xs12>
                              <small>
                                {{ utcToLocal(schedule.sort_date, 'DD/MM/YYYY h:mm A') }}
                                <br>
                                <strong>
                                  {{
                                    (schedule.type_id === 1 || schedule.type_id === 6) ? 'Gestión' :
                                      (
                                        schedule.type_id === 2 ? 'Campaña' : (
                                          schedule.type_id === 3  ? 'Prueba' : (
                                            schedule.type_id === 4 ? 'Chat Cerrado' : (
                                              schedule.type_id === 5 ? 'Mensaje Chatcenter enviado' : (
                                                schedule.type_id === 7 ? 'Inbound' : (
                                                  schedule.type_id === 9 ? 'Derivada' : ''
                                                )
                                              )
                                            )
                                          )
                                        )
                                      )
                                   }}
                                </strong>
                              </small>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                        <v-flex md4>
                          <v-layout row wrap>
                            <v-flex xs12 class="word-wrap">
                              <v-tooltip left>
                                <span slot="activator">{{schedule.to}}</span>
                                <span>{{schedule.to}}</span>
                              </v-tooltip>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                        <v-flex md2>
                          <v-layout row wrap>
                            <v-flex xs12 class="word-wrap">
                                <span>{{customer.ns_informative == 0 ? 'Cobranza' : 'Informativo'}}</span>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                        <v-flex md2 class="text-xs-right mr-4">
                          <v-chip
                          slot="activator"
                          color="transparent"
                          :class="{'f1-2em text-light color-chip':true, 'blue--text':schedule.status_id === 12, 'green--text':schedule.status_id === 8 || schedule.status_id === 14 || schedule.status_id === 20 || schedule.status_id === 13 || schedule.status_id === 9, 'red--text':schedule.status_id === 24 || schedule.status_id === 39 || schedule.status_id === 29 || schedule.status_id === 19 || schedule.status_id === 11 || schedule.status_id === 16 || schedule.status_id === 23, 'orange--text':schedule.status_id === 21 || schedule.status_id === 35 || schedule.status_id === 30 || schedule.status_id === 15 || schedule.status_id === 25 || schedule.status_id === 6 || schedule.status_id === 22 || schedule.status_id === 33 }"
                          >
                          {{ storeStatus(schedule.status_id).status }}
                          <v-icon small class="pl-2" v-if="schedule.status_id === 6">fas fa-user-times</v-icon>
                          <v-icon small class="pl-2" v-if="schedule.status_id === 8">fas fa-calendar-check</v-icon>
                          <v-icon small class="pl-2" v-if="schedule.status_id === 9">fas fa-headset</v-icon>
                          <v-icon small class="pl-2" v-if="schedule.status_id === 11">fas fa-hand-paper</v-icon>
                          <v-icon small class="pl-2" v-if="schedule.status_id === 12">fas fa-clock</v-icon>
                          <v-icon small class="pl-2" v-if="schedule.status_id === 13">fas fa-user-check</v-icon>
                          <v-icon small class="pl-2" v-if="schedule.status_id === 14">fas fa-check</v-icon>
                          <v-icon small class="pl-2" v-if="schedule.status_id === 15">fas fa-user-slash</v-icon>
                          <v-icon small class="pl-2" v-if="schedule.status_id === 16">fas fa-times</v-icon>
                          <v-icon small class="pl-2" v-if="schedule.status_id === 19">fas fa-times</v-icon>
                          <v-icon small class="pl-2" v-if="schedule.status_id === 20">fas fa-book-open</v-icon>
                          <v-icon small class="pl-2" v-if="schedule.status_id === 22">fas fa-user-clock</v-icon>
                          <v-icon small class="pl-2" v-if="schedule.status_id === 23">fas fa-comment-slash</v-icon>
                          <v-icon small class="pl-2" v-if="schedule.status_id === 24">report_off</v-icon>
                          <v-icon small class="pl-2" v-if="schedule.status_id === 25">fas fa-ban</v-icon>
                          <v-icon small class="pl-2" v-if="schedule.status_id === 29">fas fa-clipboard-check</v-icon>
                          <v-icon small class="pl-2" v-if="schedule.status_id === 30">voice_over_off</v-icon>
                          <v-icon small class="pl-2" v-if="schedule.status_id === 33">fas fa-bell-slash</v-icon>
                          <v-icon small class="pl-2" v-if="schedule.status_id === 35">fas fa-calendar-times</v-icon>
                          <v-icon small class="pl-2" v-if="schedule.status_id === 39">fas fa-trash</v-icon>
                        </v-chip>
                      </v-flex>
                      </v-layout>
                    </template>
                    <v-card class="white" flat>
                      <v-card-text class="text-medium-light grey--text pr-3">
                        <div v-if="notificationSchedule.channel_id === 1 || notificationSchedule.channel_id === 2" class="pl-4">
                          <div v-html="notificationSchedule.text ? notificationSchedule.text : 'Sin mensaje'" v-if="notificationSchedule.channel_id == 1">
                          </div>
                          <span v-else>
                            {{ notificationSchedule.text ? notificationSchedule.text : 'Sin mensaje' }}
                          </span>
                          <br/><br/>

                            <!--Show Description-->
                          <div v-if="schedule.descrip !== null" class="black--text" >
                            Descripción: <span class="grey--text">{{ schedule.descrip }}</span>
                          </div>
                          <br/>
                        </div>
                        <div v-if="notificationSchedule.channel_id === 5 || notificationSchedule.channel_id === 6">
                          <div :class="{
                            'text-xs-center': !notificationSchedule.descrip,
                            'text-xs-justify': notificationSchedule.descrip }">
                            <strong v-if="notificationSchedule.descrip">Comentario</strong>
                            <br>
                            <span v-html="notificationSchedule.descrip ? notificationSchedule.descrip : 'Sin mensaje'">
                            </span>
                          </div>
                        </div>
                        <template v-if="notificationSchedule.channel_id === 6 || notificationSchedule.channel_id === 4 || notificationSchedule.channel_id === 3 || notificationSchedule.channel_id === 5">
                          <av-line
                            v-if="notificationSchedule.url_record && canSeeAudio"
                            :line-width="1"
                            :canv-width="600"
                            :canv-heigh="80"
                            line-color="#ff7c64"
                            :canv-top="true"
                            :cors-anonym="true"
                            class="customized-audio"
                            :audio-src="`${notificationSchedule.url_record}`"
                          ></av-line>
                          <span v-else class="d-block text-xs-center">
                            No posee audio.
                            <template v-if="notificationSchedule.channel_id === 3 && canSeeAudio">
                              <hr class="my-3 w-50 mx-auto">
                              <h5 class="text-xs-left">
                                Texto
                              </h5>
                              <audio-text class="text-xs-left" :notification-schedule="notificationSchedule">
                              </audio-text>
                            </template>
                          </span>
                        </template>
                        <v-divider class="white"></v-divider>
                        <v-card flat>
                          <v-card-text  class="px-0 py-1">

                            <template v-for="(item, i) in dates" >
                              <v-layout :key="`${i}-date`"  v-if="i === 0 || more === true" row wrap  class="pt-2">
                                <v-flex md2 class="text-xs-center">

                                  <v-avatar
                                    size="50"
                                    class="transparent"
                                    >
                                    <v-icon class="k-orange-linear-text">{{ item.icon }}</v-icon>
                                  </v-avatar>
                                </v-flex>
                                <v-flex md8>
                                  <v-layout row wrap>
                                    <v-flex md12>
                                      {{ item.text }}
                                    </v-flex>
                                    <v-flex md12>
                                      <small>{{ utcToLocal( item.date, item.dateFormat) }}</small>
                                    </v-flex>
                                  </v-layout>
                                </v-flex>
                              </v-layout>
                            </template>
                          </v-card-text>
                          <v-layout row wrap justify-end v-if="dates.length > 1">
                            <v-flex md2>
                              <v-btn small block flat class="k-orange-linear-text" v-if="notificationSchedule.channel_id === 1" @click="downloadPdf(notificationSchedule.id)">
                                <v-icon small>fas fa-download</v-icon>
                                Descargar
                              </v-btn>
                            </v-flex>
                            <v-flex md2 v-if="more !== true" @click="more = true">
                              <v-btn small block class="k-orange-linear-text" flat>
                                Ver mas
                              </v-btn>
                            </v-flex>
                            <v-flex md2 v-if="more" @click="more = false">
                              <v-btn small block class="k-orange-linear-text" flat>
                                Ver menos
                              </v-btn>
                            </v-flex>
                          </v-layout>
                        </v-card>
                      </v-card-text>
                    </v-card>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-layout>
            </vue-perfect-scrollbar>
            <v-layout justify-center align-center fill-height v-else class="white">
              <v-flex md12 text-xs-center>
                <v-icon large>fas fa-info-circle</v-icon>&nbsp;&nbsp;&nbsp;
                <span class="pt-3 f1-5em">No se encontraron resultados</span>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex md5 class="pt-3 l-borders white-no-border">
        <v-card class="elevation-0">
          <customer-contacted-notifications
            :customer="customer"
            :items="nsContacts"
            :loading="loading">
          </customer-contacted-notifications>
        </v-card>
      </v-flex>
    </v-layout>
    <v-dialog
      v-model="duesDialog"
      :max-width="$auth.user().company_id === 8230622 ? '850px' : $auth.user().company_id === 83806105 ? '1250px' : '950px'"
      persistent
    >
      <v-card class="pa-4">
        <v-card-title>
          <h2>
          {{ duesName }}
          </h2>
        </v-card-title>
        <v-card-text>
          <customer-dues :tab="`tab-4`" :customer="customer" :is-flat="true" v-if="duesDialog && $auth.user().company_id === 8230622">
          </customer-dues>
          <customer-dues-v2
            :tab="`tab-4`"
            :customer="customer"
            :is-flat="true"
            @ns-created="addNs"
            v-if="duesDialog && $auth.user().company_id !== 8230622">
          </customer-dues-v2>
        </v-card-text>
        <v-card-actions>
          <v-btn color="black" class="ml-auto" flat @click.stop="duesDialog = false">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!--
    <refinancing-dialog
      :show="refinancingDialog"
      :customer="customer"
      @close="refinancingDialog = false"/>
       -->
    <notification-pending
      :show="notificationPending"
      :customer="customer"
      @close="notificationPending = false"/>
    <save-dialog
      :title="title"
      :dialog="dialogSchedule"
      :form="formSchedule"
      :route="route"
      :edit="edit"
      :hasMore="false"
      :more="false">
      <template slot="content">
        <template v-if="dialogSchedule">
          <v-layout row wrap>
            <v-flex md6 pr-2>
              <v-select
                v-model="formSchedule.channel"
                :items="channelsFormatted"
                item-value="id"
                item-text="text"
                v-validate="'required'"
                data-vv-name="channel"
                data-vv-as="canal"
                :error-messages="errors.collect('channel')"
                label="Canal"
                color="black">
              </v-select>
            </v-flex>
            <v-flex md6 pl-2>
              <v-select
                v-model="formSchedule.status"
                :items="statusesForm"
                v-validate="'required'"
                item-text="status"
                item-value="value"
                :data-vv-name="'Estado'"
                :data-vv-as="'Estado'"
                :error-messages="errors.collect('status')"
                label="Estado"
                color="black">
              </v-select>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex md12 v-if="formSchedule.channel !== 5">
              <v-select
                v-model="template"
                :items="templates"
                v-validate="'required'"
                item-text="name"
                return-object
                :data-vv-name="'template_id'"
                :data-vv-as="'Plantilla'"
                :error-messages="errors.collect('template_id')"
                label="Plantilla"
                color="black">
              </v-select>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex class="md6" pl-2>
              <v-select
                v-model="formSchedule.to"
                :items="customer[`customer_${formSchedule.channel === 1 || formSchedule.channel === 8  ? 'email' : 'phone'}s`]"
                v-validate="'required'"
                :item-text="formSchedule.channel === 1 || formSchedule.channel === 8  ? 'email' : 'phone'"
                :item-value="formSchedule.channel === 1 || formSchedule.channel === 8  ? 'email' : 'phone'"
                data-vv-name="to"
                :data-vv-as="formSchedule.channel === 1 || formSchedule.channel === 8  ? 'email' : 'telefono'"
                :error-messages="errors.collect('to')"
                :label="formSchedule.channel === 1 || formSchedule.channel === 8  ? 'email' : 'Telefono'"
                color="black">
              </v-select>
            </v-flex>
            <v-flex md6 pl-2>
              <v-select
                v-model="formSchedule.currency"
                :items="currencies"
                v-validate="'required'"
                item-text="name"
                item-value="id"
                :data-vv-name="'Tipo de moneda'"
                :data-vv-as="'Tipo de moneda'"
                :error-messages="errors.collect('currency')"
                label="Tipo de moneda"
                color="black">
              </v-select>
            </v-flex>
          </v-layout>
          <template v-if="formSchedule.status === 8">
            <v-layout row wrap>
              <v-flex md12>
                <v-menu
                  ref="from"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  :return-value.sync="formSchedule.date"
                  transition="scale-transition"
                  min-width="290px"
                  lazy
                  offset-y
                  full-width>
                    <v-text-field
                      slot="activator"
                      v-model="dateFormatted"
                      append-icon="event"
                      label="Fecha de compromiso"
                      readonly
                      color="black">
                    </v-text-field>
                    <v-date-picker
                      v-model="formSchedule.date"
                      @input="$refs.from.save(formSchedule.date)"
                      locale="es"
                      color="k-orange-linear">
                    </v-date-picker>
                </v-menu>
              </v-flex>
            </v-layout>
          </template>
          <v-layout row wrap>
            <v-flex md12>
              <v-text-field
                color="black"
                label="Descripción"
                v-model="formSchedule.descrip">
              </v-text-field>
            </v-flex>
          </v-layout>
          <template v-if="(formSchedule.channel != 5 && formSchedule.channel != 4) && template.id">
            <v-layout row wrap>
              <v-flex md12 class="my-2 f1-3em grey--text">
                Texto de plantilla
              </v-flex>
              <v-flex md12>
                <div v-html="formatedText(this.template[formScheduleChannelField])"></div>
              </v-flex>
            </v-layout>
          </template>
        </template>
      </template>
    </save-dialog>
    <v-dialog v-model="showPayments" max-width="750px" persistent>
      <v-card class="pa-4">
        <v-card-title>
          <h2>
            Pagos
          </h2>
        </v-card-title>
        <v-card-text>
          <customer-payments v-if="showPayments" flat :customer="customer"></customer-payments>
        </v-card-text>
        <v-card-actions>
          <v-btn color="black" class="ml-auto" flat @click.stop="showPayments = false">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="showAgreements" max-width="900px" persistent>
      <v-card class="pa-4">
        <v-card-title>
          <h2>
            Convenios
          </h2>
        </v-card-title>
        <v-card-text class="agreements-dialog__content pa-0">
          <agreements-tab
            v-if="showAgreements"
            :key="`agreements-${customer.id}`"
            flat
            :customer="customer">
          </agreements-tab>
        </v-card-text>
        <v-card-actions>
          <v-btn color="black" class="ml-auto" flat @click.stop="showAgreements = false">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <chat-room
      key="chat-room"
      v-if="showChatRoom"
      :chat="chat"
      :show="showChatRoom"
      :creating="true"
      :user="user"
      :has-customer="true"
      :answer-template="templateSelected"
      @reload-message="reloadMessage"
      @updateSendedMessage="updateSendedMessage"
      @appendMessagesToChat="handleAppend"
      @openAnswerTemplates="openAnswerTemplate"
      @close="closeChat">
    </chat-room>
    <answer-templates
      :show="showAnswerTemplate"
      :channel="chat.channel_id"
      @selected="selectAnswerTemplate"
      @close="closeAnswerTemplates">
    </answer-templates>
    <call-center-dialer
      v-if="isCalling"
      :notification="callNotification"/>
    <!-- <individual
      :show="individualCall"
      @save="startCall"
      @close="individualCall = false"/> -->
    <v-snackbar
      :bottom="true"
      v-model="reconnecting"
      :timeout="0"
      top>
      Perdida de conexion con el servidor de llamadas, reconectando...
    </v-snackbar>
    <customer-tracking-logs-dialog
      :show="showCustomerTrackingLogsDialog"
      :customer="customer"
      @close="showCustomerTrackingLogsDialog = false"
    />
  </v-container>
</template>
<script>
import Vue from 'vue';
import moment from 'moment';
import Avatar from 'vue-avatar';
import { mapGetters } from 'vuex';
import _ from 'lodash';
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import EventBus from '@/event-bus';
import permissionsMixin from '@/mixins/permissions';
import StatusMixin from '@/mixins/status';
import ChannelMixin from '@/mixins/channels';
import saveDialogMixin from '@/mixins/saveDialog';
import dimentionsMixin from '@/mixins/dimentions';
import ChatRoom from '@/components/chat_center_v2/ChatRoom';
import AudioText from '@/components/global/AudioText';
import DataTable from '@/components/global/DataTable';
import saveDialog from '@/components/global/SaveDialog';
import AnswerTemplates from '@/components/chat_center_v2/AnswerTemplates';
import CustomerPayments from './CustomerPayments';
import CallCenterDialer from '@/components/CallCenter/Dialer';
import RefinancingDialog from '@/components/customer/RefinancingDialog';
import CustomerMovements from '@/components/chat_center/CustomerMovements';
import NotificationPending from '@/components/customer/NotificationPendingDialog';
import CallCenterStatusModal from '@/components/CallCenter/Status';
import movements from './MovementList';
import BalanceInfo from './BalanceInfo';
import CustomerDues from './CustomerDues';
import CustomerDuesV2 from './CustomerDuesV2';
import FinancialInfo from './FinancialInfo';
import OtherInfo from './OtherInfo';
import CustomerContactedNotifications from './CustomerContactedNotifications';
import Individual from './Individual';
import CustomerTrackingLogsDialog from './CustomerTrackingLogsDialog';
import AgreementsTab from '@/components/agreements/AgreementsTab';
Vue.component('movements', movements);

export default {
  inject: ['$validator'],
  mixins: [
    ChannelMixin,
    StatusMixin,
    saveDialogMixin,
    dimentionsMixin,
    permissionsMixin,
  ],
  components: {
    Avatar,
    ChatRoom,
    AudioText,
    DataTable,
    OtherInfo,
    saveDialog,
    Individual,
    BalanceInfo,
    CustomerDues,
    FinancialInfo,
    CustomerDuesV2,
    AnswerTemplates,
    CallCenterDialer,
    CustomerPayments,
    AgreementsTab,
    CustomerMovements,
    RefinancingDialog,
    VuePerfectScrollbar,
    NotificationPending,
    CallCenterStatusModal,
    CustomerTrackingLogsDialog,
    CustomerContactedNotifications,
  },
  beforeRouteLeave(to, from, next) {
    if (
      this.$store.state.dialer.callCenterStatus === 3
      && !(
        to.name === 'CallListWait'
        && this.$store.state.dialer.notification.type_id === 7
        && !this.$store.state.dialer.notification.customer_id
      )
      && !(
        to.name === 'CustomerShow'
        && this.$store.state.dialer.notification.customer_id === to.params.customer
      )
    ) {
      EventBus.$emit('modal', 'No puede salir mientras esta en una llamada');
    } else {
      next();
    }
  },
  beforeRouteUpdate(to, from, next) {
    this.customer.id = to.params.customer;
    this.getPannel('notification_schedules');
    this.getCustomer(null, null);
    this.updateStatus();
    next();
  },
  created() {
    this.$store.dispatch('GET_BILLS', { customer_id: this.$route.params.customer });
    EventBus.$emit('hideMenu');
    if (this.$store.state.dialer.callCenterStatus !== 0) {
      EventBus.$emit('hideMenu');
      this.showMoreBinance = true;
    }
    this.getPannel('notification_schedules');
    this.updateStatus();
    this.$store.dispatch('GET_CURRENCIES');
    this.getCustomer(null, null);
    EventBus.$on('closeMovementsDialog', () => {
      this.movementsDialog.dialog = false;
    });
    EventBus.$on('closeModal', () => {
      this.dialogSchedule = false;
      this.formSchedule = {
        customer_id: this.$route.params.customer,
        status: '',
        to: '',
        date: moment().format('YYYY-MM-DD'),
        template_id: '',
        channel: 1,
        descrip: '',
      };
    });
    EventBus.$on('created', () => {
      this.getPannel('notification_schedules');
    });
    EventBus.$on('update', () => {
      this.getPannel('notification_schedules');
    });
    this.loading = true;
    this.axios.get(`/customers/notifications-contacted/${this.$route.params.customer}`).then(({ data }) => {
      this.nsContacts = data;
      this.loading = false;
    }).catch(() => {
      this.loading = false;
    });
    this.startListeningEvents();
    this.startCallFromUrlQuery();
  },
  destroyed() {
    this.stopListeningEvents();
  },
  data() {
    return {
      showAnswerTemplate: false,
      individualCall: false,
      step: 0,
      active: 'tab-1',
      loading: false,
      showChatRoom: false,
      cancelToken: this.axios.CancelToken.source(),
      chat: {
        id: 0,
        internal_id: 0,
        channel_id: 0,
        customer: {},
        company_id: 0,
        fetch_messages: false,
        chat_center_messages: [],
      },
      tabItems: [
        {
          name: 'Gestiones',
          value: 'notification_schedules',
        },
        {
          name: 'Pagos',
          value: 'payment',
        },
      ],
      formSchedule: {
        customer_id: this.$route.params.customer,
        status: '',
        to: '',
        date: moment().format('YYYY-MM-DD'),
        template_id: '',
        channel: 1,
        descrip: '',
      },
      showPayments: false,
      showAgreements: false,
      status: [],
      template: {},
      dialogSchedule: false,
      route: 'notification_schedules',
      movementsDialog: {
        dialog: false,
        userId: 0,
        movementType: '',
      },
      showMoreBinance: false,
      showMoreOther: false,
      stopMusic: false,
      editingCustomer: false,
      editCustomer: false,
      editEmail: false,
      editPhone: false,
      more: false,
      templates: [],
      channels: [],
      types: [
        {
          name: 'SMS',
          value: 'sms',
        },
        {
          name: 'Llamadas',
          value: 'calls',
        },
        {
          name: 'Emails',
          value: 'emails',
        },
        {
          name: 'IVR',
          value: 'ivr',
        },
        {
          name: 'Bot',
          value: 'bot',
        },
      ],
      sortList: [
        {
          name: 'Fecha',
          value: '-date',
        },
        {
          name: 'Monto',
          value: '-amount',
        },
      ],
      customer: {
        id: this.$route.params.customer,
        customer_phones: [],
        customer_emails: [],
        account: '',
      },
      notificationState: 1,
      dates: [],
      notificationSchedule: {},
      notificationSchedules: [],
      filters: {
        seach: '',
        type: '',
        sort: '',
      },
      filterTimeline: {
        status: '',
        search: '',
      },
      typeCustomers: {
        phone: [
          {
            type: 'Celular',
          },
          {
            type: 'Fijo',
          },
        ],
        email: [
          {
            type: 'Principal',
          },
        ],
      },
      form: {
        email: {
          email: '',
          type: '',
          agent_id: null,
          origin_id: 3,
        },
        sub_status_id: null,
        status_id: 0,
        payment_promise: moment().format('DD/MM/YYY'),
        phone: {
          telefono: '',
          type: '',
          origin_id: 3,
        },
      },
      showName: 'gestión',
      statuses: [],
      statusesForm: [],
      createEmail: false,
      createPhone: false,
      duesDialog: false,
      refinancingDialog: false,
      notificationPending: false,
      checkActivity: () => {},
      nsContacts: [],
      showDownload: false,
      selectedNsId: '',
      selectedNumber: '',
      showCustomerTrackingLogsDialog: false,
      templateSelected: {},
    };
  },
  computed: {
    ...mapGetters({
      state: 'state',
      agent: 'agent',
      agency: 'agency',
      agents: 'agents',
      gender: 'gender',
      tranche: 'tranche',
      ageGroup: 'age_group',
      storeStatus: 'status',
      account: 'account_type',
      dimentions: 'dimentions',
      genders: 'genders',
      portfolio: 'portfolio_type',
      currencies: 'currencies',
      primaryCurrency: 'primaryCurrency',
    }),
    reconnecting() {
      return (
        (
          this.$store.state.dialer.callCenterStatus !== 0
          && this.$store.state.dialer.reconnecting
        ) || (
          this.$store.state.dialerV2.status
          && this.$store.state.dialer.reconnecting
        )
      );
    },
    aliviaCheck() {
      let status = 'Inactivo';
      if (this.customer.alivia_enabled === 1) {
        status = 'Activo';
      }
      return status;
    },
    statusCustomers() {
      return {
        customer: this.$store.getters.customerStatuses,
        contacts: [
          'Equivocado',
          'Invalido',
          'Por validar',
          'Valido',
        ],

      };
    },
    callNotification() {
      return this.$store.state.dialer.notification;
    },
    isCalling() {
      return this.$store.state.dialer.callCenterStatus !== 0 || this.$store.state.dialer.callType === 'manual' || this.$store.state.dialer.callType === 'manual_v2';
    },
    dateFormattedPaymentPromise() {
      return moment(this.form.payment_promise || moment().format('YYYY-MM-DD'), 'YYYY-MM-DD').format('DD/MM/YYYY');
    },
    dateFormatted() {
      return moment(this.formSchedule.date, 'YYYY-MM-DD').format('DD/MM/YYYY');
    },
    dateMinFormatted() {
      return moment(this.filterTimeline.schedule_date, 'YYYY-MM-DD').format('DD/MM/YYYY');
    },
    channelsFormatted() {
      if (this.channels.length) {
        return this.channels.filter(x => ![11].includes(x.id)).map((item) => {
          // eslint-disable-next-line
          item.text = this.showNameChannel(item.id, 'upperAll');
          return item;
        });
      }
      return [];
    },
    formScheduleChannelField() {
      if (this.formSchedule.channel === 1 || this.formSchedule.channel === 8) {
        return 'text';
      } else if (this.formSchedule.channel === 2) {
        return 'sms';
      } else if (this.formSchedule.channel === 3) {
        return 'ivr';
      }
      return 'text';
    },
    selectedTemplate() {
      if (this.formSchedule.template_id) {
        const index = this.templates.findIndex(item => item.id === this.formSchedule.template_id);
        if (index !== -1) {
          return this.templates[index];
        }
      }
      return {};
    },
    duesName() {
      let name = 'Cuotas';
      if (this.$auth.user().company_id === 8230622) {
        name = 'Polizas';
      }
      return name;
    },
    user() {
      return this.$auth.user();
    },
    channel() {
      return `company.${this.user.company.id}.chatCenter`;
    },
    hasInfo() {
      const keys = Object.keys(this.customer);
      return keys.filter(item => item.includes('info_')).length > 0;
    },
    canCreateContact() {
      return this.checkPermissions([
        'create_contacts',
      ]);
    },
    canEditContact() {
      return this.checkPermissions([
        'edit_contact',
      ]);
    },
    canSeeMasked() {
      return this.checkPermissions([
        'see_masked_data',
      ]);
    },
    canCallContact() {
      return this.checkPermissions([
        'call_contact',
        'see_customer_tracking',
      ]);
    },
    canSeeAudio() {
      return this.checkPermissions([
        'see_recordings',
      ]);
    },
  },
  filters: {
    transformBirthday(value) {
      if (value) {
        return moment(value, 'YYYY-MM-DD').format('DD/MM/YYYY');
      }
      return 'Sin información';
    },
  },
  methods: {
    getPhoneOrigin(originId) {
      let origin = '';
      switch (originId) {
        case 1:
          origin = 'Carga';
          break;
        case 2:
          origin = 'Campañas';
          break;
        case 3:
          origin = 'Manual';
          break;
        case 4:
          origin = 'Poblamiento';
          break;
        case 5:
          origin = 'Chatcenter';
          break;
        default:
          origin = 'Sin definir';
          break;
      }
      return origin;
    },
    getPhoneContactabilityLabel(phone) {
      if (phone.in_validation === null || phone.in_validation === undefined) {
        return 'Contactabilidad indefinida';
      }
      return Number(phone.in_validation) === 1 ? 'Baja contactabilidad' : 'Contactable';
    },
    getPhoneContactabilityClass(phone) {
      if (phone.in_validation === null || phone.in_validation === undefined) {
        return 'contactability-chip--unknown';
      }
      return Number(phone.in_validation) === 1
        ? 'contactability-chip--low'
        : 'contactability-chip--good';
    },
    closeChat() {
      this.chat = {
        id: 0,
        internal_id: 0,
        channel_id: 0,
        customer: {},
        company_id: this.user.company_id || this.customer.company_id,
        fetch_messages: false,
        chat_center_messages: [],
      };
      this.showChatRoom = false;
    },
    makeChatCenter(contact, channel) {
      this.chat.internal_id = channel === 1 ? contact.email : contact.phone;
      this.chat.channel_id = channel;
      this.chat.contact_id = contact.id;
      this.chat.chat_center_messages = [];
      this.chat.company_id = this.user.company_id || this.customer.company_id;
      this.chat.customer = this.customer;
      this.cancelToken.cancel('');
      this.cancelToken = this.axios.CancelToken.source();
      this.axios.get(`chats_center/${this.chat.id}/messages`, {
        cancelToken: this.cancelToken.token,
        params: {
          ...this.chat,
        },
      }).then(({ data }) => {
        if (data.length) {
          this.chat.id = data[0].chat_center_id;
        }
        this.chat.chat_center_messages = data;
      }).catch(() => {}).then(() => {
        this.showChatRoom = true;
      });
    },
    startListeningEvents() {
      this.checkActivity = setInterval(() => {
        if (this.chat.id) {
          this.axios.get('chats_center/presence');
        }
      }, 600000);
      window.Echo.private(this.channel)
        .listen('.ChatCenterUpdated', (event) => {
            let chatCenter = {};
            if (event.chatCenter) {
              chatCenter = event.chatCenter;
            } else {
              chatCenter = event;
            }
            if (chatCenter.id === this.chat.id) {
              this.updateChatInList(chatCenter);
            }
          })
        .listen('.ChatCenterMessageUpdated', ({ ChatCenterMessage }) => {
          // eslint-disable-next-line
          if (this.chat.chat_center_messages.length) {
            const message = this.chat.chat_center_messages.findIndex(x => x.id === ChatCenterMessage.id || x.identifier);
            if (message >= 0) {
              this.$set(this.chat.chat_center_messages, message, {
                ...this.chat.chat_center_messages[message],
                ...ChatCenterMessage,
              });
            }
          }
        });
    },
    stopListeningEvents() {
      window.Echo.leave(this.channel);
      clearInterval(this.checkActivity);
    },
    updateChatInList(chatCenter) {
      const messages = this.chat.chat_center_messages;
      const newMessages = _.uniqBy(messages.concat(chatCenter.chat_center_messages), 'id');
      const newItem = {
        ...this.chat,
        ...chatCenter,
      };
      newItem.chat_center_messages = _.orderBy(newMessages, 'created_at', 'asc');
      this.chat = newItem;
    },
    reloadMessage($event) {
      // console.log('reloadMessage', $event);
    },
    updateSendedMessage($event) {
      // console.log('updateSendedMessage', $event);
      if ($event.id === this.chat.id) {
        const index = this.chat.chat_center_messages.findIndex(item => item.identifier && item.identifier === $event.identifier);
        if (index >= 0) {
          this.$set(this.chat.chat_center_messages, index, {
            ...this.chat.chat_center_messages[index],
            ...$event.chatCenterMessage,
          });
        }
      }
    },
    generateReport() {
      this.$store.commit('SET_DOWNLOAD_CHANNEL', `company.${this.$auth.user().company.id}.${this.$auth.user().id}.download_report`);
      this.$store.dispatch('SEND_DOWNLOAD_REQUEST', {
        route: 'reports',
        params: {
          filters: {
            customer: this.customer.id,
            filename: `Gestiones del cliente ${this.customer.name}`,
            status: (this.filterTimeline.status.value > 0 ? this.filterTimeline.status.value : ''),
            search: this.filterTimeline.search,
          },
          functionName: 'managementTotal',
        },
      });
    },
    /* eslint-disable */
    formatedText(text) {
      if (text && text !== '') {
        let replace, variableText;
        Object.keys(this.customer).forEach((key, i) => {
          variableText = `@${key === 'account' ? 'cuenta' : key === 'first_name' ? 'nombre' : key === 'last_name' ? 'apellido' : key === 'c_to' ? 'email' : key === 'agency' ? 'agencia' : key === 'due_date' ? 'fecha_de_vencimiento' : key === 'invoiced_balance' ? 'monto' : key}`;
          if (i === 0) {
            replace = text.replace(variableText, `<span class="highlight-campaign-template">${this.customer[key]}</span>`);
          } else {
            replace = replace.replace(variableText, `<span class="highlight-campaign-template">${this.customer[key]}</span>`);
          }
        });
        return replace;
      }
    },
    getChannels() {
      this.axios.get('channels', {
        params: {
          except: [7,8,9],
        },
      }).then(({ data }) => {
        this.channels  = data;
      });
    },
    getTemplates(channel) {
      if (channel !== 4 && channel !== 5) {
        this.axios.get(`templates?fields=name,id,text,sms,ivr&paginate=0&notNull=${channel}&status=activo`).then((response) => {
          this.templates = response.data;
          if (response.data.length) {
            this.template = response.data[0];
          }
        }).catch(() => { });
      } else if (channel === 4) {
        this.axios.get('bot_templates?fields=name,id,text,sms,ivr&paginate=0&status=activo').then((response) => {
          this.templates = response.data;
          if (response.data.length) {
            this.template = response.data[0];
          }
        }).catch(() => { });
      }
    },
    /* eslint-enable */
    getStatus() {
      this.axios.get(`notification_schedules/status?channel=${this.formSchedule.channel}&type=1&except=1,2,3,4,14,9,11,12,5,27,29,28`)
        .then((res) => {
          this.statusesForm = res.data;
          this.formSchedule.status = res.data[0].status;
        });
    },
    setStatus(type, id, status) {
      this.axios.patch(`customer_${type}s/${id}`, {
        status,
      }).then(() => {
        this.getCustomer();
      }).catch(() => { });
    },
    closeEditPhone() {
      this.form.phone = {};
      this.editPhone = false;
    },
    closeEditEmail() {
      this.form.email = {};
      this.editEmail = false;
    },
    editSelectEmail(email) {
      if (email === 'create') {
        this.createEmail = true;
      }
      if (email !== 'create' && this.canEditContact) {
        this.form.email.email = email.email;
        this.form.email.type = email.type;
        this.form.email.id = email.id;
        this.editEmail = email.id;
      }
    },
    editSelectPhone(phone) {
      if (phone === 'create') {
        this.createPhone = true;
      }
      if (phone !== 'create' && this.canEditContact) {
        this.form.phone.telefono = phone.phone;
        this.form.phone.tipoPhone = phone.type;
        this.form.phone.id = phone.id;
        this.editPhone = phone.id;
      }
    },
    callCustomer(phone) {
      // this.individualCall = true;
      this.selectedNumber = phone;
      return this.startCall({});

      // TODO: recordar que en llamada directa hace 'callTimeAndAlert/SET_STATUS_MANUAL_CALL' a true
      // this.$store.dispatch('dialer/startManual', {
      //  phone,
      //  customer_id: this.customer.id,
      // });
    },
    startCall({}) {
      return this.$store.dispatch('manualCalls/startLiveKit', {
        phone: this.selectedNumber,
        customer_id: this.customer.id,
      });
    },
    editSelectCustomer(customer) {
      this.form.nombre = customer.name;
      this.form.cuenta = customer.account;
      this.form.fiscal = customer.fiscal_id;
      this.form.genero = customer.gender_id;
      this.form.edad = customer.age;
      this.form.id = customer.id;
      this.form.status_id = customer.customer_status_id;
      this.form.sub_status_id = customer.sub_status_id;
      this.form.payment_promise = customer.payment_promise;
      this.editCustomer = true;
    },
    updateStatus() {
      this.axios.get(`/notification_schedules/live_status?customer_id=${this.customer.id}`).then((response) => {
        this.statuses = response.data;
        const totalStatus = this.sum('total', this.statuses);
        this.statuses.unshift({
          status: 'Estados',
          value: -1,
          total: totalStatus,
        });
      });
    },
    sum(prop, array) {
      let total = 0;
      for (let i = 0; i < array.length; i += 1) {
        total += array[i][prop];
      }
      return total;
    },
    /* eslint-disable */
    getPannel(item) {
      if (item.value === 'payment') {
        EventBus.$emit('update');
      }
      if (item.value !== 'payment') {
        this.axios.get(`customers/${this.customer.id}/notification_schedules?paginate=0${this.filterTimeline.status ? `&status=${this.filterTimeline.status.value}` : ''}${this.filterTimeline.search ? `&search=${this.filterTimeline.search}` : ''}`).then((response) => {
          this.notificationSchedules = _.orderBy(response.data.map(item => ({
            ...item,
            sort_date: item.failed_at || (item.refused_at || (item.wrong_person_at || (item.voicemail_at || (item.contacted_at || (item.delivered_at || (item.sent_carrier_at || (item.schedule_date)))))))
          })), item => moment.utc(item.sort_date, 'YYYY-MM-DD HH:mm:ss'), ['desc']);
        });
      }
    },
    /* eslint-enable */
    getScheduleData(type) {
      this.selectSchedule = type;
    },
    utcToLocal(date, format) {
      return moment.utc(date).local().format(format);
    },
    formatDate(date, formatDate, format) {
      return moment(date, formatDate).format(format);
    },
    formatDateNormal(date) {
      return moment(date).format('DD/MM/YYYY h:mm A');
    },
    getStep(event, step) {
      this.dates = [];
      this.more = false;
      this.notificationSchedule = {};
      if (event) {
        this.axios.get(`/notification_schedules/${this.notificationSchedules[step].id}?customer_id=${this.customer.id}&sort=-schedule_date`).then((response) => {
          this.notificationSchedule = response.data;
          if (response.data.processed_at !== null) {
            this.dates.push({
              text: 'Gestión procesada',
              icon: 'fas fa-clipboard-list',
              dateFormat: 'DD/MM/YYYY h:mm A',
              date: response.data.processed_at,
            });
          }
          if (response.data.sent_carrier_at !== null) {
            this.dates.push({
              text: 'Enviado al operador',
              icon: 'fas fa-clipboard-list',
              dateFormat: 'DD/MM/YYYY h:mm A',
              date: response.data.sent_carrier_at,
            });
          }
          if (response.data.sent_at !== null) {
            this.dates.push({
              text: 'Enviado al cliente',
              icon: 'fas fa-clipboard-list',
              dateFormat: 'DD/MM/YYYY h:mm A',
              date: response.data.sent_at,
            });
          }
          if (response.data.delivered_at !== null) {
            this.dates.push({
              text: 'Entregado al cliente',
              icon: 'fas fa-clipboard-list',
              dateFormat: 'DD/MM/YYYY h:mm A',
              date: response.data.delivered_at,
            });
          }
          if (response.data.read_at !== null) {
            this.dates.push({
              text: 'Leido',
              icon: 'fas fa-clipboard-list',
              dateFormat: 'DD/MM/YYYY h:mm A',
              date: response.data.read_at,
            });
          }
          if (response.data.click_at !== null) {
            this.dates.push({
              text: `Click a ${this.notificationDetail.url}`,
              icon: 'fas fa-clipboard-list',
              dateFormat: 'DD/MM/YYYY h:mm A',
              date: response.data.click_at,
            });
          }
          if (response.data.payment_promise !== null) {
            this.dates.push({
              text: 'Se comprometió',
              icon: 'fas fa-clipboard-list',
              dateFormat: 'DD/MM/YYYY',
              date: moment(response.data.payment_promise).utc(),
            });
          }
          if (response.data.failed_at !== null) {
            this.dates.push({
              text: 'Error',
              icon: 'fas fa-exclamation-triangle ',
              dateFormat: 'DD/MM/YYYY h:mm A',
              date: response.data.failed_at,
            });
          }
        });
      }
    },
    getCustomer(update = null, type = null) {
      this.axios.get(`/customers/${this.customer.id}`).then((response) => {
        this.customer = response.data;
        if (response.data.code && response.data.code === 403) {
           const newRoute = this.checkPermissions([
          'see_call_center',
          ]) ? '/calls_lists' : '/inicio';
          EventBus.$emit('error', response.data.message);
          return this.$router.push(newRoute);
        }
        if (update && type) {
          this[`edit${type.charAt(0).toUpperCase()}${type.substr(1, 50).toLowerCase()}`] = false;
          this.form[type] = {};
        } else if (update && !type) {
          this.editCustomer = false;
          this.form.nombre = '';
          this.form.cuenta = '';
          this.form.fiscal = '';
          this.form.genero = 0;
          this.form.edad = '';
          this.form.agent_id = null;
        }
      });
    },
    showMovements(type) {
      this.$nextTick(() => {
        EventBus.$emit('showMovements', type, this.customer.id);
      });
    },
    updateCustomer() {
      const obj = {};
      if (this.form.nombre) {
        obj.name = (this.form.nombre ? this.form.nombre.toUpperCase() : '');
      }
      if (this.form.cuenta) {
        obj.account = this.form.cuenta;
      }
      if (this.form.fiscal) {
        obj.fiscal_id = this.form.fiscal;
      }
      if (this.form.genero) {
        obj.gender_id = this.form.genero;
      }
      if (this.form.edad) {
        obj.age = this.form.edad;
      }
      if (this.form.status_id) {
        obj.customer_status_id = this.form.status_id;
      }
      if (this.form.sub_status_id) {
        obj.sub_status_id = this.form.sub_status_id;
      } else {
        obj.sub_status_id = null;
      }
      if (this.form.status_id === 2) {
        if (this.form.payment_promise) {
          obj.payment_promise = this.form.payment_promise;
        } else {
          obj.payment_promise = moment().format('YYYY-MM-DD');
        }
      }
      if (this.form.agent_id) {
        obj.agent_id = this.form.agent_id;
      }
      this.axios.patch(`/customers/${this.customer.id}`, obj).then(() => {
        if (this.form.status_id === 2) {
          this.axios.post('notification_schedules', {
            channel: 5,
            to: '',
            customer_id: this.customer.id,
            status: 8,
            manual: true,
            payment_promise: obj.payment_promise,
            currency: this.primaryCurrency.id,
          }).then(() => {
            this.getPannel('notification_schedules');
          });
        }
        this.getCustomer(true);
      }).catch(() => {});
    },
    updateEmail(item, type = null) {
      if (type != null) {
        this.axios.post('/customer_emails', {
          customer_id: this.customer.id,
          email: item.email.toLowerCase(),
          type: item.type,
          origin_id: 3,
        }).then(() => {
          this.createEmail = false;
          this.getCustomer(true, 'email');
        }).catch((error) => {
          console.log(error.response);
          if (error.response) {
            console.log(error.response.status);
            if (error.response.status === 422) {
              console.log(error.response.data.message); // Should output "El email se encuentra en lista negra"
              EventBus.$emit('modal', error.response.data.errors.email[0]);
            }
          }
        });
      } else {
        this.axios.patch(`/customer_emails/${item.id}`, {
          email: item.email.toLowerCase(),
          type: item.type,
        }).then(() => {
          this.getCustomer(true, 'email');
        }).catch((error) => {
          console.log(error.response);
          if (error.response) {
            console.log(error.response.status);
            if (error.response.status === 422) {
              console.log(error.response.data.message); // Should output "El email se encuentra en lista negra"
              EventBus.$emit('modal', error.response.data.errors.email[0]);
            }
          }
        });
      }
    },
    updatePhone(item, type = null) {
      if (type != null) {
        this.axios.post('/customer_phones', {
          customer_id: this.customer.id,
          phone: item.telefono.toLowerCase(),
          type: item.tipoPhone,
          origin_id: 3,
        }).then(() => {
          this.createPhone = false;
          this.getCustomer(true, 'phone');
        }).catch((error) => {
          console.log(error.response);
          if (error.response) {
            console.log(error.response.status);
            if (error.response.status === 422) {
              console.log(error.response.data.errors.phone[0]); // Should output "El numero se encuentra en lista negra"
              EventBus.$emit('modal', error.response.data.errors.phone[0]);
            }
          }
        });
      } else {
        this.axios.patch(`/customer_phones/${item.id}`, {
          phone: item.telefono.toLowerCase(),
          type: item.tipoPhone,
        }).then(() => {
          this.getCustomer(true, 'phone');
        }).catch((error) => {
           if (error.response) {
            if (error.response.status === 422) {
              console.log(error.response.data.errors.phone[0]); // Should output "El numero se encuentra en lista negra"
              EventBus.$emit('modal', error.response.data.errors.phone[0]);
            }
          }
        });
      }
    },
    capitalize(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    resetValidator() {
      this.$validator.reset();
      this.errors.clear();
    },
    downloadPdf(id) {
      this.axios.get(`/customer/${this.customer.id}/download/ns/${id}`, {
        responseType: 'blob',
      }).then((response) => {
        // this.downloadFile(response, 'Gestion');
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'file.pdf');
        document.body.appendChild(link);
        link.click();
      });
    },
    cloneDownloadModal() {
      this.showDownload = false;
      this.selectedNsId = '';
    },
    downloadFile(response, filename) {
      // It is necessary to create a new blob object with mime-type explicitly set
      // otherwise only Chrome works like it should
      var newBlob = new Blob([response.body], {type: 'application/pdf'})

      // IE doesn't allow using a blob object directly as link href
      // instead it is necessary to use msSaveOrOpenBlob
      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(newBlob)
        return
      }

      // For other browsers:
      // Create a link pointing to the ObjectURL containing the blob.
      const data = window.URL.createObjectURL(newBlob)
      var link = document.createElement('a')
      link.href = data
      link.download = filename + '.pdf'
      link.click()
      setTimeout(function () {
        // For Firefox it is necessary to delay revoking the ObjectURL
        window.URL.revokeObjectURL(data)
      }, 100)
    },
    addNs($event) {
      this.notificationSchedules.unshift($event)
    },
    startCallFromUrlQuery() {
      if ((this.$route.query || {}).start_manual_call) {
        this.$router.replace({query: {}});
        this.axios.get(`customers_tracking/${this.$route.params.customer}/check_manual_call_redirect`)
          .then(({ data }) => {
            if (data.phone && data.extension) {
              this.selectedNumber = data.phone;
              this.startCall({
                extension_number: data.extension,
                new_server: false,
              });
            }
          })
          .catch(() => {});
      }
    },
    openAnswerTemplate($event) {
      this.showAnswerTemplate = true;
    },
    closeAnswerTemplates() {
      this.showAnswerTemplate = false;
    },
    selectAnswerTemplate($event) {
      this.templateSelected = $event;
      this.closeAnswerTemplates()
    },
    handleAppend($event) {
      this.templateSelected = {};
      this.chat.chat_center_messages.push($event);
    }
  },
  watch: {
    minDate(val) {
      this.filters['min-created_at'] = val;
      const [year, month, day] = val.split('-');
      this.minDateFormatted = `${day}/${month}/${year}`;
    },
    maxDate(val) {
      this.filters['max-date'] = val;
      const [year, month, day] = val.split('-');
      this.maxDateFormatted = `${day}/${month}/${year}`;
    },
    filterTimeline: {
      handler() {
        this.getPannel('notification_schedules');
      },
      deep: true,
    },
    dialogSchedule(val) {
      if (val) {
        this.getChannels();
        this.getStatus();
      }
    },
    'formSchedule.channel'(val) { // eslint-disable-line
      this.getStatus();
      this.getTemplates(val);
    },
    template(val) {
      if (val) {
        this.formSchedule.template_id = val.id;
        if (!val.name) {
          this.template.name = '';
        }
      }
    },
    formSchedule: {
      deep: true,
      handler() {
        this.resetValidator();
      },
    },
  },
};
</script>

<style scoped>
.chat-center-container >>> .chat-modal {
  max-height: 95% !important;
  overflow: visible;
}
.chat-center-container >>> .chat-config-modal {
  overflow: visible;
}
.infoTable > .row {
    margin-left: 9px;
}
.infoTable{
  border: 1px solid #d0c9c9;
  border-width: 0.5px;
  padding: 4px;
}
.hovereable:hover {
  background: rgba(0,0,0,0.12);
  cursor:pointer;
}
.font-weight-medium{
  font-weight: 500;
}
.chat-details--scrollbar {
  max-height: 150px;
}
.fade-enter-active, .fade-leave-active {
  transition: opacity .2s
}
.fade-enter, .fade-leave-to
/* .fade-leave-active in <2.1.8 */ {
  opacity: 0
}
.call-button {
  height: 30px !important;
  width: 30px !important;
  margin: 0 !important;
}
.call-button i {
  font-size: 15px;
}
.w-80 {
  width: 80%;
}
.card-btn {
  cursor: pointer;
}
.card-btn >>> .card__text {
  height: 50px;
}
.card-container {
  display: flex;
  justify-content: space-around;
}
.card-container .card-btn {
  flex: 1 1 0;
  min-width: 0;
}
.phone-icon-container {
  min-width: auto !important;
}
.contact-method-tile {
  padding-right: 8px !important;
}
.contact-method-tile >>> .list__tile {
  padding-right: 8px;
  height: auto;
  min-height: 64px;
}
.contact-method-leading {
  min-width: 40px !important;
  margin-right: 4px !important;
}
.contact-method-content {
  min-width: 0 !important;
  overflow: hidden;
}
.contact-method-title {
  display: flex !important;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px;
  white-space: normal !important;
}
.contact-method-phone {
  margin-right: 2px;
}
.contact-method-meta {
  display: flex !important;
  flex-wrap: wrap;
  align-items: center;
  gap: 4px;
  white-space: normal !important;
  max-height: none !important;
  padding-top: 2px;
}
.contact-method-actions {
  min-width: auto !important;
  max-width: none !important;
  margin: 0 0 0 8px !important;
  align-self: center;
}
.contact-method-actions__group {
  display: flex;
  align-items: center;
  flex-shrink: 0;
  gap: 6px;
}
.contactability-chip {
  margin: 0 !important;
  border: none !important;
  color: #fff !important;
  font-weight: 500;
}
.contactability-chip >>> .chip__content {
  color: #fff !important;
  height: 18px;
  padding: 0 8px;
}
.contactability-chip--good {
  background-color: #4CAF50 !important;
}
.contactability-chip--low {
  background-color: #F44336 !important;
}
.contactability-chip--unknown {
  background-color: #9E9E9E !important;
}
</style>



// WEBPACK FOOTER //
// src/components/customer/Detail.vue